export default '''
	# TODO
	type Comment {
		id: ID!
	}
	type Annotation {
		id: ID!
	}
'''
